import { locales } from '@americanexpress/conditional-features';

const {
  JA_JP,
  EN_US,
} = locales;

// Locales that allow a minimum of 2 characters for search. Default is 3 characters
export const hasTwoCharactersSearchRule = [JA_JP];
export const TWO_CHARS_MINIMUM_QUERY_LENGTH = 2;

export const hasDevFlagPopularLocationsRule = {
  devFlag: 'popularDestinationsLocations',
  devLocales: [],
  prodLocales: [JA_JP],
};

export const hasRecentSearchAirDisplayRule = [EN_US];

export const hasRecentSearchHotelDisplayRule = [EN_US];
// Replace with One XP Feature Flags
